(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CollaborationDialogController', CollaborationDialogController);

    CollaborationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Collaboration'];

    function CollaborationDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Collaboration) {
        var vm = this;
        vm.collaboration = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:collaborationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.collaboration.id !== null) {
                Collaboration.update(vm.collaboration, onSaveSuccess, onSaveError);
            } else {
                Collaboration.save(vm.collaboration, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
